import { isEmpty, uniqBy } from 'lodash'

import { filterModifiableConfirmationModalitySalesChannels } from 'features/Trips/utils'
import {
  GTTripV2,
  GTTripV2ConfirmationModality,
  GTTripV2ConfirmationModalityName,
  GTTripV2ConfirmationModalitySalesChannel
} from 'gql/types.generated'

export const getUpdatedConfirmationModalities = (
  confirmationModalities: GTTripV2ConfirmationModality[]
): GTTripV2ConfirmationModality[] => {
  const paidModality = confirmationModalities.find(
    (modality) => modality.name === GTTripV2ConfirmationModalityName.Paid
  )

  if (!paidModality) {
    throw new Error('Paid modality not found')
  }

  const newReservedSalesChannels = filterModifiableConfirmationModalitySalesChannels(paidModality.salesChannels)

  if (isEmpty(newReservedSalesChannels)) {
    return [...confirmationModalities]
  }

  const reservedModality = confirmationModalities.find(
    (modality) => modality.name === GTTripV2ConfirmationModalityName.Reserved
  )
  const untouchedModalities = confirmationModalities.filter(
    (modality) => modality.name !== GTTripV2ConfirmationModalityName.Reserved
  )

  if (isEmpty(reservedModality)) {
    return [
      ...untouchedModalities,
      {
        name: GTTripV2ConfirmationModalityName.Reserved,
        salesChannels: newReservedSalesChannels,
        exceptions: paidModality.exceptions
      }
    ]
  }

  return [
    ...untouchedModalities,
    {
      ...reservedModality,
      salesChannels: uniqBy([...reservedModality.salesChannels, ...newReservedSalesChannels], 'id')
    }
  ]
}

export const getImpactedSalesChannels = (
  trips: Pick<GTTripV2, 'confirmationModalities'>[]
): GTTripV2ConfirmationModalitySalesChannel[] => {
  const paidSalesChannels = trips.reduce((acc, trip) => {
    const paidModality = trip.confirmationModalities.find(
      (modality) => modality.name === GTTripV2ConfirmationModalityName.Paid
    )
    if (paidModality) {
      return uniqBy([...acc, ...paidModality.salesChannels], 'id')
    }
    return acc
  }, [] as GTTripV2ConfirmationModalitySalesChannel[])

  return filterModifiableConfirmationModalitySalesChannels(paidSalesChannels)
}
